import React, { Component } from "react";
import PropTypes from "prop-types";
import Multiselect from "react-bootstrap-multiselect";
import * as Constants from '../constants';

class CompanyGeekAIForm extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
    handleSaveSources: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      ai_source_names: this.props.company.ai_source_names,
    };
  }

  getSelectedSourceNames() {
    const sourceNames = Constants.GEEK_AI_SYSTEM_SOURCES;
    const savedSourceNames = this.state.ai_source_names;

    let selectedSourceNames = [];

    Object.keys(sourceNames).forEach(key => {
      const sourceNameValues = sourceNames[key];
      const result = sourceNameValues.every(name => savedSourceNames.includes(name));
      if (result === true) {
        selectedSourceNames.push(key);
      }
    });

    return selectedSourceNames;
  }

  sourceOptions() {
    if (this.props.company.source_names) {
      const sourceNames = Constants.GEEK_AI_SYSTEM_SOURCES;
      const selectedSourceNames = this.getSelectedSourceNames();
      const options = Object.keys(sourceNames).map(sourceName => {
        const selected = selectedSourceNames.includes(sourceName);
        return { value: sourceName, selected: selected };
      }, this);

      return options;
    }
  }

  getMultiselectValues(ref) {
    const source_names = Constants.GEEK_AI_SYSTEM_SOURCES;

    const options = [].slice.call(ref.selectRef.options);

    const selected = options.filter(function(option) {
      return option.selected;
    });

    const selectedValues = selected.map(function(option) {
      return source_names[option.value];
    });

    const mergedSources = [].concat.apply([], selectedValues);
    return mergedSources;
  }

  handleChange() {
    const ai_source_names = this.getMultiselectValues(this.source_names);

    this.props.handleSaveSources( { ai_source_names: ai_source_names });
    this.setState({
      ai_source_names: ai_source_names
    });
  }

  render() {
    return (
      <div>
        <div className="panel panel-default campaign_filters m-t-20">
          <div className="panel-heading">
            <h3 className="panel-title">
              New Lead Triggers
            </h3>
          </div>
          <div className="panel-body">
            <div>
              <span className="" style={{ fontWeight: "normal" }}>
                Geek AI will be enabled for new leads from these sources.
              </span>
              <form className="filters_form">
                <div className={`row form-group`}>
                  <div className="col-sm-12 m-l-0 p-0 campaign_ai_sources">
                    <label className="filter_label">Lead Source</label>
                    <Multiselect
                      ref={(c) => { this.source_names = c; }}
                      data={this.sourceOptions()}
                      className="form-control filter_select"
                      onChange={this.handleChange.bind(this)}
                      buttonText={function(options, select) {
                        if (options.length > 1) {
                          return options.length + " selected";
                        } else if (options.length == 1) {
                          return options[0].label;
                        } else {
                          return "None selected";
                        }
                      }}
                      multiple
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="alert alert-info text-center">
          <p>
            Geek AI: Automated Assistant is active for { this.getSelectedSourceNames().length } lead sources.
          </p>
          <br/>
          <p>
            GeekAI will automatically disable all text messages sent from Drip and Lead Manager so there will not be conflicting automation.          <br/>
            Email and follow-up steps in Drip workflows will still send as expected. <a target="_blank" rel="noopener noreferrer" href="https://support.realgeeks.com/hc/en-us/articles/360057072713-GeekAI-Texting-Assistant">Read more</a>
          </p>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { company: state.company.company };
}

export default CompanyGeekAIForm;
